import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import YousignSignFrame from './YousignSignFrame';

/**
 * Step 4 — embedded Yousign signing. The contract has already been created, so
 * the recipient details can no longer be edited in place: to change them the
 * user must cancel the current contract, which returns to the preview step.
 */
export default function YousignSignContractStep({ contractId, signatureLink, onSuccess, onCancel }) {
  const { t: tSign } = useTranslation(undefined, { keyPrefix: 'Components:Contract:SignStep' });

  return (
    <div>
      <YousignSignFrame
        contractId={contractId}
        signatureLink={signatureLink}
        onSuccess={onSuccess}
        onDeclined={onCancel}
        backButton={
          <Button color="default" variant="solid" onClick={onCancel}>
            {tSign('buttons.edit_contract')}
          </Button>
        }
      />
    </div>
  );
}
